<template>
  <div>
    <AtomicUiDropdownBasic
      :model-value="dropdownValue"
      name="sort-by"
      label="Sort By"
      :options="sortByOptions"
      @update:model-value="dropdownUpdate"
    />
  </div>
</template>

<script setup>
import { GET_ALL_SELECTED_CRITERIA, UPDATE_SORTBY_SELECTED } from '~/types/actions';
import useDisplay from '~/composables/filteringFacets/useDisplay';
import useSortFilter from '~/composables/filteringFacets/useSortFilter';
import { useFilteringFacetsStore } from '~/stores/filteringFacets';

const filteringFacetsStore = useFilteringFacetsStore();
const { screen } = useDisplay();
const { updateSortBy, selections } = useSortFilter();

const dropdownValue = computed(() => {
  if (screen.value.isMobile) {
    return selections.value.sortBySelectedValue;
  }
  return filteringFacetsStore.sortBy.selectedValue;
});
const dropdownUpdate = (selected) => {
  if (screen.value.isMobile) {
    updateSortBy(selected);
  } else {
    filteringFacetsStore[UPDATE_SORTBY_SELECTED](selected);
    filteringFacetsStore[GET_ALL_SELECTED_CRITERIA]();
  }
};
const sortByOptions = computed(() => filteringFacetsStore.sortBy.sortByOptions);
</script>

<style lang="scss" scoped>
:deep(.select-container) {
  margin-top: 0;
  margin-bottom: 0;
}
</style>
